import React, {useState,useEffect} from 'react'
import makeCarousel from 'react-reveal/makeCarousel';
import Fade from 'react-reveal/Fade';
import { withStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
    chevronPrev:{
        position: 'absolute',
        top: '50%',
        left: 0,
        zIndex: 10,
        // background: 'white',
        // borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        [theme.breakpoints.down('sm')]: {
          left: theme.spacing(0),
          width: '36px',
          height: '36px',
          background: '#00000066',
        },
        cursor: 'pointer',
      },
      chevronNext:{
        position: 'absolute',
        top: '50%',
        right: 0,
        zIndex: 10,
        // background: 'white',
        // borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        [theme.breakpoints.down('sm')]: {
          right: theme.spacing(0),
          width: '36px',
          height: '36px',
          background: '#00000066',
        },
        cursor: 'pointer'
      },
      iconChevron:{
        fontSize: '2.5rem',
        color: 'white',
        [theme.breakpoints.down('sm')]: {
          fontSize: '2rem',
        }
      },
      carouselDots:{
        position:'absolute',
        bottom: theme.spacing(3),
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      },
      boxHeaderGallery:{
        // background: '#000000b3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '5%'
      },
      iconCloseGallery:{
        position: 'absolute',
        right: 0,
        top: '8px',
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]:{
          right: theme.spacing(1),
        }
      }
  })

const Gallery = (props) => 
{ 
  const { position, children, classes, items, activeIndex, closeGallery } = props

  const [current, setCurrent] = useState(activeIndex)

  const nextCarousel = () => {
    let index = current
    if(index === (items.length-1)){
      setCurrent(0)
    }else{
      setCurrent(++index)
    }
  }

  const prevCarousel = () => {
    let index = current
    if(index === 0){
      setCurrent(items.length-1)
    }else{
      setCurrent(--index)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      nextCarousel()
    }, 5000);
    return () => clearInterval(interval);
  }, [current]);

    return (
        <Box>
          <Box className={classes.boxHeaderGallery}>
            <Typography variant="body1"> 
              {current+1} of {items.length}
            </Typography>
            <CloseIcon className={classes.iconCloseGallery} onClick={closeGallery}/>
          </Box>
          <Box style={{overflow:'hidden'}}>
            {items.map((item,index) => (
                <>
                {current === index &&
                    <div style={{ position: "absolute", left: 0, top: '5%', width: '100%', opacity: 1.0, height: '95%' }}>
                        <Fade>
                        <div style={{backgroundImage:`url(`+(item.images.length > 0 ? item.images[0].image_url : '')+`)`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPosition:'center', height: '100%'}}>
                        </div>
                        </Fade>
                    </div>
                }
                </>
            ))}
            <>
              <Box className={classes.chevronNext}>
                <ChevronRightIcon className={classes.iconChevron} onClick={nextCarousel}/>
              </Box>
              <Box className={classes.chevronPrev}>
                <ChevronLeftIcon className={classes.iconChevron} onClick={prevCarousel}/>
              </Box>
            </>
          </Box>
          {/* <Box className={classes.carouselDots}>
            {Array(...Array(total)).map( (val, index) =>
                <span key={index} onClick={handleClick} data-position={index}>
                {index === position ? '● ' : '○ ' }
                </span>
            )}
          </Box> */}
        </Box>
      );
}

export default withStyles(styles)(Gallery);